// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c7fe7ac4","247":"cedec465","627":"394f0ce1","834":"281fe9f7","867":"293a2a72","923":"85c26d67","938":"ca38bfc2"}[chunkId] + ".chunk.js";
};